import type { ReactNode } from 'react';

export const symbol_currency_rupee: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M555-129 299.2-393.83Q294-399 292-404.5t-2-12.17v-20q0-14.16 9.49-23.75Q308.98-470 323-470h97q57 0 100-37t50-103H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h295q-13-48-53.57-79T420-780H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h420q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H566q23 20 39 51t23 59h62q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-60q-8 91-67.36 145.5Q503.29-410 420-410h-52l231 240q14 14 5.98 32t-27.87 18q-6.11 0-11.61-2-5.5-2-10.5-7Z"
		/>
	</svg>
);
